import { render, staticRenderFns } from "./OrgControls.vue?vue&type=template&id=5d2e5f1e"
import script from "./OrgControls.vue?vue&type=script&lang=js"
export * from "./OrgControls.vue?vue&type=script&lang=js"
import style0 from "./OrgControls.vue?vue&type=style&index=0&id=5d2e5f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports